(function() {
  'use strict';

  let elements = {
    overlay: null,
    drawer: null,
    content: null,
    closeButton: null
  };

  function initQuickView() {
    if (elements.overlay) return;

    const overlay = document.createElement('div');
    overlay.className = 'quick-view-overlay';
    overlay.id = 'quick-view-overlay';

    const drawer = document.createElement('div');
    drawer.className = 'quick-view-drawer';
    drawer.id = 'quick-view-drawer';

    const closeButton = document.createElement('button');
    closeButton.className = 'quick-view-drawer__close';
    closeButton.setAttribute('aria-label', 'Close quick view');
    closeButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 4L4 14M4 4L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    const content = document.createElement('div');
    content.className = 'quick-view-drawer__content';

    drawer.appendChild(content);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    document.body.appendChild(closeButton);

    elements = { overlay, drawer, content, closeButton };

    closeButton.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    setupMobileSwipe(drawer);
  }

  function setupMobileSwipe(drawer) {
    let touchStartY = 0;
    let touchCurrentY = 0;

    drawer.addEventListener('touchstart', function(e) {
      if (window.innerWidth > 749) return;
      const content = e.target.closest('.quick-view-drawer__content');
      if (!content || content.scrollTop !== 0) return;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    drawer.addEventListener('touchmove', function(e) {
      if (window.innerWidth > 749 || touchStartY === 0) return;
      touchCurrentY = e.touches[0].clientY;
      const diff = touchCurrentY - touchStartY;
      if (diff > 0) {
        drawer.style.transform = `translateY(${diff}px)`;
      }
    }, { passive: true });

    drawer.addEventListener('touchend', function() {
      if (window.innerWidth > 749 || touchStartY === 0) return;
      const diff = touchCurrentY - touchStartY;
      if (diff > 100) {
        closeDrawer();
      } else {
        drawer.style.transform = '';
      }
      touchStartY = 0;
      touchCurrentY = 0;
    });
  }

  function checkScrollState() {
    const drawer = document.querySelector('.quick-view-drawer');
    const content = document.querySelector('.quick-view-drawer__content');
    if (!drawer || !content) return;

    if (content.scrollHeight > content.offsetHeight) {
      drawer.classList.add('has-scroll');
    } else {
      drawer.classList.remove('has-scroll');
    }
  }

  function openDrawer(productHandle) {
    initQuickView();

    const { overlay, drawer, content } = elements;

    content.innerHTML = `
      <div class="quick-view-loading">
        <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;

    overlay.classList.add('active');
    drawer.classList.add('active');
    document.body.classList.add('quick-view-open');

    fetch(`/products/${productHandle}?view=quick-view`)
      .then(response => response.text())
      .then(html => {
        content.innerHTML = html;

        initGalleryNavigation();
        initVariantHandling();
        initFormSubmission();
        fixQuickViewSwatches();

        setTimeout(() => {
          checkScrollState();
        }, 100);

        setTimeout(() => {
          if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 50);

        document.dispatchEvent(new CustomEvent('quickview:loaded', {
          detail: { handle: productHandle }
        }));
      })
      .catch(error => {
        console.error('Quick view error:', error);
        content.innerHTML = `
          <div style="padding: 2rem; text-align: center;">
            <p>Unable to load product. Please try again.</p>
          </div>
        `;
      });
  }

  function closeDrawer() {
    const { overlay, drawer } = elements;
    if (!overlay || !drawer) return;

    overlay.classList.remove('active');
    drawer.classList.remove('active');
    document.body.classList.remove('quick-view-open');
  }

  function initGalleryNavigation() {
    const gallery = document.querySelector('.quick-view-gallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.quick-view-slide');
    const prevBtn = gallery.querySelector('.quick-view-nav-btn.prev');
    const nextBtn = gallery.querySelector('.quick-view-nav-btn.next');
    const currentSpan = gallery.querySelector('.slider-counter--current');
    let currentIndex = 0;

    function updateSlide(newIndex) {
      if (newIndex < 0 || newIndex >= slides.length) return;
      slides[currentIndex].classList.remove('active');
      slides[newIndex].classList.add('active');
      currentIndex = newIndex;
      if (currentSpan) {
        currentSpan.textContent = currentIndex + 1;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const newIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
        updateSlide(newIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const newIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
        updateSlide(newIndex);
      });
    }
  }

  function initVariantHandling() {
    const quickViewProduct = document.querySelector('.quick-view-product');
    if (!quickViewProduct) return;

    const form = quickViewProduct.querySelector('form[id^="quick-view-form-"]');
    if (!form) return;

    setTimeout(() => {
      checkInitialAvailability(form);
    }, 100);

    quickViewProduct.addEventListener('change', function(e) {
      const input = e.target;
      if (!input.matches('input[type="radio"]')) return;

      const fieldset = input.closest('fieldset.js.product-form__input');
      if (!fieldset) return;

      const legend = fieldset.querySelector('legend.form__label');
      if (!legend) return;

      const hasSwatches = fieldset.querySelector('.swatch');
      const labelText = legend.textContent.toLowerCase();
      const isColorOption = hasSwatches || labelText.includes('color') || labelText.includes('colour');

      if (isColorOption) {
        let labelSpan = legend.querySelector('.in-color-label');
        if (!labelSpan) {
          labelSpan = document.createElement('span');
          labelSpan.className = 'in-color-label';
          legend.appendChild(labelSpan);
        }
        labelSpan.textContent = ': ' + input.value;
      }

      updateVariantId(input);
    });
  }

  function checkInitialAvailability(form) {
    const hiddenInput = form.querySelector('input[name="id"]');
    if (!hiddenInput) return;

    const variantRadios = form.querySelector('variant-radios');
    if (!variantRadios) return;

    const variantData = variantRadios.querySelector('script[type="application/json"]');
    if (!variantData) return;

    try {
      const variants = JSON.parse(variantData.textContent);
      const currentVariant = variants.find(v => v.id == hiddenInput.value);

      if (currentVariant) {
        updateAvailability(currentVariant, form);

        const selectedOptions = [];
        form.querySelectorAll('fieldset.js.product-form__input').forEach(fieldset => {
          const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedInput) {
            selectedOptions.push(checkedInput.value);
          }
        });
        updateSwatchStates(form, variants, selectedOptions);
      }
    } catch(e) {
      // Silently fail
    }
  }

  function updateVariantId(changedInput) {
    const form = changedInput.closest('form');
    if (!form) return;

    const hiddenInput = form.querySelector('input[name="id"]');
    if (!hiddenInput) return;

    const variantRadios = form.querySelector('variant-radios');
    if (!variantRadios) return;

    const variantData = variantRadios.querySelector('script[type="application/json"]');
    if (!variantData) return;

    try {
      const variants = JSON.parse(variantData.textContent);

      const selectedOptions = [];
      form.querySelectorAll('fieldset.js.product-form__input').forEach(fieldset => {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
        }
      });

      const matchingVariant = variants.find(variant => {
        return variant.options.every((optValue, idx) => {
          return selectedOptions[idx] === optValue;
        });
      });

      if (matchingVariant) {
        hiddenInput.value = matchingVariant.id;
        updateAvailability(matchingVariant, form);
        updateSwatchStates(form, variants, selectedOptions);
      }
    } catch(e) {
      // Silently fail
    }
  }

  function updateSwatchStates(form, variants, currentSelections) {
    const fieldsets = form.querySelectorAll('fieldset.js.product-form__input');

    fieldsets.forEach((fieldset, optionIndex) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach(input => {
        const optionValue = input.value;
        const testSelections = [...currentSelections];
        testSelections[optionIndex] = optionValue;

        const hasAvailableVariant = variants.some(variant => {
          let matches = true;
          for (let i = 0; i < testSelections.length; i++) {
            if (testSelections[i] && variant.options[i] !== testSelections[i]) {
              matches = false;
              break;
            }
          }
          return matches && variant.available;
        });

        if (hasAvailableVariant) {
          input.removeAttribute('data-unavailable');
        } else {
          input.setAttribute('data-unavailable', 'true');
        }
      });
    });
  }

  function updateAvailability(variant, form) {
    let submitButton = document.querySelector('.quick-view-add-btn');

    if (!submitButton) {
      submitButton = document.querySelector('button[form="' + form.id + '"][type="submit"]');
    }

    if (!submitButton) {
      submitButton = form.querySelector('button[type="submit"][name="add"]');
    }

    if (!submitButton) return;

    const badgesContainer = document.querySelector('.quick-view-badges');

    if (variant.available) {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
      const textSpan = submitButton.querySelector('span');
      if (textSpan) textSpan.textContent = 'Add to cart';

      if (badgesContainer) {
        const soldOutBadge = badgesContainer.querySelector('.badge--sold-out');
        if (soldOutBadge) soldOutBadge.remove();
      }
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
      const textSpan = submitButton.querySelector('span');
      if (textSpan) textSpan.textContent = 'Sold out';

      if (badgesContainer) {
        const badgeStyle = document.documentElement.getAttribute('data-badge-style') || 'square';
        badgesContainer.innerHTML = `<span class="badge badge--sold-out badge--${badgeStyle}">Sold out</span>`;
      }
    }
  }

  function fixQuickViewSwatches() {
    const swatches = document.querySelectorAll('.quick-view-product .product-swatch__label');
    swatches.forEach(function(label) {
      if (label.classList.contains('product-swatch__label--rectangle')) {
        label.style.setProperty('width', (28 * 1.6) + 'px', 'important');
        label.style.setProperty('height', '28px', 'important');
        label.style.setProperty('min-width', (28 * 1.6) + 'px', 'important');
        label.style.setProperty('min-height', '28px', 'important');
        label.style.setProperty('border-radius', '0', 'important');
      } else if (label.classList.contains('product-swatch__label--square')) {
        label.style.setProperty('width', '28px', 'important');
        label.style.setProperty('height', '28px', 'important');
        label.style.setProperty('min-width', '28px', 'important');
        label.style.setProperty('min-height', '28px', 'important');
        label.style.setProperty('border-radius', '0', 'important');
      } else {
        label.style.setProperty('width', '28px', 'important');
        label.style.setProperty('height', '28px', 'important');
        label.style.setProperty('min-width', '28px', 'important');
        label.style.setProperty('min-height', '28px', 'important');
        label.style.setProperty('border-radius', '50%', 'important');
      }
    });
  }

  function initFormSubmission() {
    const submitButton = document.querySelector('.quick-view-add-btn');
    if (!submitButton) return;

    const formId = submitButton.getAttribute('form');
    const form = document.getElementById(formId);
    if (!form) return;

    submitButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (submitButton.disabled || submitButton.classList.contains('loading')) return;

      const formData = new FormData(form);
      const variantId = formData.get('id');

      const variantRadios = form.querySelector('variant-radios');
      if (variantRadios) {
        const variantData = variantRadios.querySelector('script[type="application/json"]');
        if (variantData) {
          try {
            const variants = JSON.parse(variantData.textContent);
            const selectedVariant = variants.find(v => v.id == variantId);
            if (!selectedVariant || !selectedVariant.available) return;
          } catch(e) {
            // Silently fail
          }
        }
      }

      submitButton.disabled = true;
      submitButton.classList.add('loading');

      // Ensure the spinner exists. Some custom-options apps strip the button's
      // inner nodes after render, removing the spinner div; recreate it so the
      // loading state always shows, matching the product page.
      let spinner = submitButton.querySelector('.loading-overlay__spinner');
      if (!spinner) {
        spinner = document.createElement('div');
        spinner.className = 'loading-overlay__spinner';
        spinner.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
        submitButton.appendChild(spinner);
      }
      spinner.classList.remove('hidden');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          alert(response.description || 'Unable to add to cart');
          return;
        }

        closeDrawer();

        if (!cart) {
          window.location.href = '/cart';
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          setTimeout(() => {
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          }, 100);
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        submitButton.classList.remove('loading');
        submitButton.disabled = false;
        if (spinner) spinner.classList.add('hidden');
        alert('Unable to add item to cart');
      })
      .finally(() => {
        setTimeout(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
            const sp = submitButton.querySelector('.loading-overlay__spinner');
            if (sp) sp.classList.add('hidden');
          }
        }, 100);
      });
    });
  }

  document.addEventListener('click', function(e) {
    const quickAddButton = e.target.closest('.quick-add-button');
    if (!quickAddButton) return;

    e.preventDefault();
    e.stopPropagation();

    const productHandle = quickAddButton.dataset.productHandle;
    if (!productHandle) return;

    quickAddButton.classList.add('is-loading');

    const variantCount = parseInt(quickAddButton.dataset.variantCount);
    if (variantCount === 1) {
      const variantId = quickAddButton.dataset.variantId;
      addToCartDirectly(variantId, quickAddButton);
      return;
    }

    openDrawer(productHandle);

    setTimeout(() => {
      quickAddButton.classList.remove('is-loading');
    }, 500);
  });

  function addToCartDirectly(variantId, button) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    if (button) {
      button.classList.add('loading');
      button.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => response.json())
    .then(response => {
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(response);
        setTimeout(() => {
          if (cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        }, 100);
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));

      if (button) {
        button.classList.remove('loading');
        button.classList.remove('is-loading');
        button.classList.add('added');
        setTimeout(() => {
          button.classList.remove('added');
          button.disabled = false;
        }, 2000);
      }
    })
    .catch(error => {
      console.error('Direct add to cart error:', error);
      if (button) {
        button.classList.remove('loading');
        button.classList.remove('is-loading');
        button.disabled = false;
      }
      alert('Unable to add item to cart');
    });
  }

  document.addEventListener('quickview:open', function(e) {
    var handle = e.detail && e.detail.handle;
    if (handle) {
      openDrawer(handle);
    }
  });

})();
